import styled from "styled-components";

export const GameClubChatWrapper = styled.div<{ showGNB: boolean }>`
  position: relative;
  margin: 20px 16px;
  display: flex;
  flex-direction: column;
  height: calc(100vh - ${({ showGNB }) => (showGNB ? "300px" : "190px")});
  overflow: hidden;

  > .info {
    font-weight: 500;
    font-size: 10px;
    text-align: center;
    color: #a6a6a6;
    flex-shrink: 0;
  }
`;

export const GameClubChatContent = styled.div<{
  showGNB: boolean;
  isIos: boolean;
}>`
  border-radius: 8px;
  background: #1f212799;
  color: #fff;
  margin-top: 10px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  ${({ showGNB, isIos }) => (showGNB ? "" : isIos ? "margin-top: 200px;" : "")}

  > .chat-wrapper {
    flex: 1;
    max-height: calc(100vh - 30px);
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    padding: 10px;
    gap: 10px;
    overscroll-behavior: contain;

    .date {
      font-weight: 500;
      font-size: 10px;
      text-align: center;
      margin-bottom: 10px;
    }

    > .date-wrapper {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .mine {
      display: flex;
      justify-content: flex-end;
      .message {
      }
    }

    .member {
      display: flex;
      justify-content: flex-start;
      gap: 4px;

      > img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
  }
`;

export const GameClubChatMessageWrapper = styled.div<{ isMain: boolean }>`
  display: flex;
  gap: 4px;
  align-items: end;

  > .time {
    font-weight: 300;
    font-size: 11px;
    color: #a8a7a7;
  }

  > .message {
    font-weight: 500;
    font-size: 12px;
    width: auto;
    display: inline-block;
    border-radius: 8px;
    padding: 8px;
    background: ${(p) => (p.isMain ? "#6436e7" : "#ffffff33")};
    text-align: left;
    max-width: 250px;
    overflow-wrap: break-word;
  }
`;

export const GameClubChatMember = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  > .nickname {
    font-weight: 700;
    font-size: 11px;
    text-align: left;
  }
`;

export const GameClubChatInput = styled.div`
  margin-top: 34px;
  height: 36px;
  border-radius: 15px;
  background: #43434399;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  position: sticky;
  bottom: 0;
  z-index: 10;

  > input {
    border-radius: 15px;
    background: rgba(0, 0, 0, 0);
    width: 90%;

    font-weight: 600;
    font-size: 12px;
    outline: none;
    border: none;
    color: #fff;
  }

  > input::placeholder {
    color: #b7b7b7;
  }

  > img {
    width: 24px;
    height: 24px;
  }
`;
